import LANG from '@/common/lang'

export default {
  namespaced: true,
  state: {
    lang: LANG.default
  },
  mutations: {
    setLang (state, lang) {
      state.lang = lang
    }
  },
  getters: {
    lang: state => state.lang
  }
}
